import { extractMessageFromError, getErrorContext } from '@lingoda/errors';
import { captureError, captureMessage } from './capture';

export const logAndMonitorError = (error: unknown) => {
    console.error(error);
    const errorContext = getErrorContext(error);
    if (errorContext) {
        console.debug(errorContext);
    }
    captureError(error);
};

export const logAndMonitorDebugError = (error: unknown) => {
    const message = extractMessageFromError(error) ?? 'Unknown debug message';
    console.warn(message);
    const errorContext = getErrorContext(error);
    if (errorContext) {
        console.debug(errorContext);
    }
    captureMessage(message, errorContext);
};
